<template>
  <span>
    <base-button
      :disabled="isReadOnly || isPartnerAccount"
      size="sm"
      :class="'btn_extra_small btn_info white'"
      @click.native="modals.classic = true"
      >Reorder</base-button
    >
    <!-- small modal -->
    <modal
      size="lg"
      :show.sync="modals.classic"
      modalClasses="line-item-reorder-modal"
      headerClasses="justify-content-center"
    >
      <h4 slot="header" class="title title-up">REPLACEMENT ITEM REORDER</h4>
      <h5>To reorder line items, drag and drop.</h5>
      <hr />
      <div v-if="replacementItems.length > 0" class="container">
        <el-table-draggable :animate="300" @drop="updateItems">
          <el-table
            :data="replacementItems"
            :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
          >
            <el-table-column :min-width="100" align="left" label="Actions">
              <div class="table-actions">
                <span class="caret-wrapper"
                  ><i class="sort-caret ascending"></i
                  ><i class="sort-caret descending"></i
                ></span>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
        </el-table-draggable>
      </div>
      <div style="color: red" v-else> No Replacement Item to Reorder</div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.classic = false"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount || replacementItems.length === 0"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="confirm"
          >
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import ElTableDraggable from "element-ui-el-table-draggable";
import { Table , TableColumn } from "element-ui";
import Util from "../../../../../util/util";

export default {
  name: "replacement-item-reorder",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      tableColumns: [
        {
          prop: "itemNumber",
          label: "Item No",
          minWidth: 100,
        },
        // {
        //   prop: "fundCitationName",
        //   label: "Fund Citation",
        //   minWidth: 150,
        // },
        {
          prop: "stockClassName",
          label: "Class of Supply",
          minWidth: 150,
        },
        {
          prop: "stockSubClassName",
          label: "Sub Class",
          minWidth: 150,
        },
        {
          prop: "stockDescription",
          label: "stock No & Description",
          minWidth: 200,
        },
        {
          prop: "unitMeasure",
          label: "Unit Of Measure",
          minWidth: 150,
        },
        {
          prop: "requestedQuantity",
          label: "Request Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.requestedQuantity);
          },
        },
        {
          prop: "receivedQuantity",
          label: "Received Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.receivedQuantity);
          },
        },
        {
          prop: "unitPrice",
          label: "Unit Price",
          minWidth: 125,
          formatter: (value) => {
            return Util.numberWithCommas(value.unitPrice);
          },
        },
        {
          prop: "partnerItemTotal",
          label: "Partner Total",
          minWidth: 170,
          formatter: (value) => {
            return Util.numberWithCommas(value.partnerItemTotal);
          },
        },
        {
          prop: "usItemTotal",
          label: "US Total",
          minWidth: 125,
          formatter: (value) => {
            return Util.numberWithCommas(value.usItemTotal);
          },
        },
      ],
    };
  },
  components: {
    BaseButton,
    Modal,
    ElTableDraggable,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  mounted() {},
  computed: {
    ...mapGetters({
      replacementItems: "replacementItem/replacementItems",
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      updateLineItems: "lineItem/updateLineItems",
    }),
    updateItems(data) {
      //Updatie line item numbers
      let ctx = this;
      ctx.replacementItems.map((i) => {
        i.itemNumber = data.list.findIndex((x) => x.lineItemId === i.lineItemId);
        i.itemNumber++;
        return i;
      });
    },
    confirm(e) {
      let ctx = this;
      ctx
        .updateLineItems(
          ctx.replacementItems.map((i) => {
            return { lineItemId: i.lineItemId, itemNumber: i.itemNumber };
          })
        )
        .then((response) => {
          ctx.getReplacementItems(ctx.$route.params.id);
          ctx.modals.classic = false;
        });
    },
  },
};
</script>

<style>
.line-item-reorder-modal {
  min-width: 50%;
}
</style>
